/// <amd-module name="Test/TestPlansLibrary/TestCasesPivotFilter/Redux/TestCasesPivotFilterActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IIdentity } from "VSSUI/IdentityPicker";

import { ITestCasesPivotFilterBarState } from "./TestCasesPivotFilterContracts";

export const TastCasesPivotFilterActions = {
    // Action to initialize filter bar - is fired only by Redux module initialization
    initializeFilterBarState: (filterBarState: ITestCasesPivotFilterBarState) =>
        createAction(TestCasesPivotFilterActionTypes.initializeFilterBarState, { filterBarState }),

    // Action to add an identity to list of assigned to identities
    addAssignedToIdentity: (identity: IIdentity) => createAction(TestCasesPivotFilterActionTypes.addAssignedToIdentity, { identity }),

    // Action to remove an identity from list of assigned to identities
    removeAssignedToIdentity: (identity: IIdentity) => createAction(TestCasesPivotFilterActionTypes.removeAssignedToIdentity, { identity }),

    // Action to remove multiple identities from list of assigned to identities
    removeAssignedToIdentities: (identities: IIdentity[]) => createAction(TestCasesPivotFilterActionTypes.removeAssignedToIdentities, { identities }),

    // Action to update selection of assigned to identities
    updateAssignedToIdentities: (newIdentities: IIdentity[]) =>
        createAction(TestCasesPivotFilterActionTypes.updateAssignedToIdentities, { newIdentities }),

    // Action to apply the changes made to filters by querying data provider and updating view
    // This action should only be called when there an 'actual' change has happened in filter, as it resets the continuationToken
    // and hasMoreElements and would fetch the first page of items based on current filter values.
    applyFilters: () => createAction(TestCasesPivotFilterActionTypes.applyFilters)
};

export const enum TestCasesPivotFilterActionTypes {
    initializeFilterBarState = "TestPlansLibraryFilter/initializeFilterBarState",
    addAssignedToIdentity = "TestPlansLibraryFilter/addAssignedToIdentity",
    removeAssignedToIdentity = "TestPlansLibraryFilter/removeAssignedToIdentity",
    removeAssignedToIdentities = "TestPlansLibraryFilter/removeAssignedToIdentities",
    updateAssignedToIdentities = "TestPlansLibraryFilter/updateAssignedToIdentities",
    applyFilters = "TestPlansLibraryFilter/applyFilters"
}

export type TastCasesPivotFilterActions = ActionsUnion<typeof TastCasesPivotFilterActions>;
